import React from 'react'


export type RadioGroupContainerProps = {
  className?: string
  ariaLabel?: string
  ariaLabelledBy?: string
  dataTestId?: string
}

const RadioGroupContainer: React.FunctionComponent<RadioGroupContainerProps> = (props) => {
  const { children, className, ariaLabel, ariaLabelledBy, dataTestId } = props

  return (
    <div
      className={className}
      data-testid={dataTestId}
      role="radiogroup"
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
    >
      {children}
    </div>
  )
}


export default RadioGroupContainer
